import React, { useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { cn } from '../../lib/utils';
interface CarouselProps {
  images: string[];
  alt: string;
  className?: string;
  height?: 'default' | 'card';
}
export function Carousel({
  images,
  alt,
  className,
  height = 'default'
}: CarouselProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const goToPrevious = () => {
    setCurrentIndex(prevIndex => prevIndex === 0 ? images.length - 1 : prevIndex - 1);
  };
  const goToNext = () => {
    setCurrentIndex(prevIndex => prevIndex === images.length - 1 ? 0 : prevIndex + 1);
  };
  const heightClasses = height === 'card' ? 'h-[200px] md:h-[240px]' : 'aspect-video';
  return <div className={cn('relative group', className)} data-id="element-133">
      {/* Main Image */}
      <div className={cn('relative overflow-hidden rounded-xl bg-gray-50', heightClasses)} data-id="element-134">
        <img src={images[currentIndex]} alt={`${alt} - Image ${currentIndex + 1}`} className="w-full h-full object-contain" data-id="element-135" />

        {/* Navigation Arrows */}
        {images.length > 1 && <>
            <button onClick={goToPrevious} className="absolute left-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity" aria-label="Previous image" data-id="element-136">
              <ChevronLeft className="h-6 w-6" data-id="element-137" />
            </button>
            <button onClick={goToNext} className="absolute right-2 top-1/2 -translate-y-1/2 bg-black/50 hover:bg-black/70 text-white p-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity" aria-label="Next image" data-id="element-138">
              <ChevronRight className="h-6 w-6" data-id="element-139" />
            </button>
          </>}

        {/* Image Counter */}
        {images.length > 1 && <div className="absolute bottom-3 right-3 bg-black/60 text-white text-sm px-3 py-1 rounded-full" data-id="element-140">
            {currentIndex + 1} / {images.length}
          </div>}
      </div>

      {/* Dots Indicator */}
      {images.length > 1 && <div className="flex justify-center gap-2 mt-3" data-id="element-141">
          {images.map((_, index) => <button key={index} onClick={() => setCurrentIndex(index)} className={cn('h-2 rounded-full transition-all', index === currentIndex ? 'w-8 bg-primary-600' : 'w-2 bg-gray-300 hover:bg-gray-400')} aria-label={`Go to image ${index + 1}`} data-id="element-142" />)}
        </div>}
    </div>;
}